<template>
  <div class="container mx-auto mt-10">
    <h3 class="text-green font mx-10">
      <slot name="Titel"></slot>
    </h3>
    <v-card
      dir="rtl"
      max-width="310"
      min-height="240"
      class="mx-auto text-center cover mt-1 font py-10 px-3 text-white overflow-hidden"
      style="border-radius: 20px"
      ><h1 class="mb-5">{{ name }}</h1>
      {{ content }}
      <v-spacer></v-spacer>
      <v-btn class="bg-transparent d-block" elevation="0" @click="copy(content)"
        ><v-icon>mdi-content-copy</v-icon></v-btn
      >
    </v-card>
  </div>
</template>
<script>
export default {
  props: ["content", "name"],
  methods: {
    copy(text) {
      if (this.name != undefined) {
        navigator.clipboard.writeText(
          this.name +
            ":-  \n" +
            text +
            " \n بواسطة كن ايجابي © جميع الحقوق محفوظة"
        );
      } else {
        navigator.clipboard.writeText(
          text + " \n بواسطة كن ايجابي © جميع الحقوق محفوظة"
        );
      }
    },
  },
};
</script>
<style scoped>
.container {
  font-size: 18px;
}
.cover {
  line-height: 30px;
  background-image: url("../assets/cover.png");
  background-size: cover;
  background-color: #2fd07c;
}
</style>
